import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M12,2 L2,2 L2,13 L8,13 L8,14 L1,14 L1,13 L1,2 L1,1 L13,1 L13,2 L13,7 L12,7 L12,2 Z M5,5 L10.999,5 L10.999,4 L5,4 L5,5 Z M3,5 L3,4 L4,4 L4,5 L3,5 Z M5,8 L5,7 L8,7 L8,8 L5,8 Z M3,8 L3,7 L4,7 L4,8 L3,8 Z M5,11 L5,10 L7,10 L7,11 L5,11 Z M10,10 L8,10 L8,11 L10,11 L10,13 L11,13 L11,11 L13,11 L13,10 L11,10 L11,8 L10,8 L10,10 Z M3,11 L3,10 L4,10 L4,11 L3,11 Z M10.5,6 C12.985,6 15,8.015 15,10.5 C15,12.985 12.985,15 10.5,15 C8.015,15 6,12.985 6,10.5 C6,8.015 8.015,6 10.5,6 Z"/>
  </svg>
);
